import axios from 'axios'
import { getHeader, projectUrl } from './../config'

const state = {
  projectTypeList: []
}

const mutations = {
  SET_PROJECT_TYPE_LIST (state, obj) {
    state.projectTypeList = obj
  }
}

const actions = {
  getProjectTypeList: ({ commit }) => {
    axios.get(projectUrl + '/type', { headers: getHeader() })
      .then(response => {
        commit('SET_PROJECT_TYPE_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
